const { diagnostiquerObjetSyncUp } = require('./moteurDiagnosticSyncUp');

const { REACT_APP_PROXY_HOST } = process.env;

const ENDPOINT_SOURCES_SYNCUP = (REACT_APP_PROXY_HOST || '') + '/monitoring/syncup/observabilite';
const CLE_TRACES_SYNCUP = 'syncup.cockpit.traces.v1';

async function rechercherDiagnosticSyncUp({ requete }) {
  const source = await chargerSourcesObservablesSyncUp({ requete });
  tracerUsageCockpitSyncUp('recherche', { requete });
  return diagnostiquerObjetSyncUp(source, { q: requete });
}

async function chargerSourcesObservablesSyncUp({ requete }) {
  const params = new URLSearchParams();
  if (requete) params.set('q', requete);
  const url = `${ENDPOINT_SOURCES_SYNCUP}${params.toString() ? `?${params.toString()}` : ''}`;
  const reponse = await fetch(url, { method: 'GET', cache: 'no-store' });
  const texte = await reponse.text();

  if (!reponse.ok) {
    throw new Error(`HTTP ${reponse.status} - ${url}`);
  }

  return texte ? JSON.parse(texte) : {};
}

function tracerUsageCockpitSyncUp(type, details = {}) {
  const trace = {
    type,
    details,
    timestamp: new Date().toISOString(),
    chemin: typeof window !== 'undefined' ? window.location.pathname : '/cockpit/syncup',
  };

  try {
    const traces = JSON.parse(localStorage.getItem(CLE_TRACES_SYNCUP) || '[]');
    localStorage.setItem(CLE_TRACES_SYNCUP, JSON.stringify([trace].concat(traces).slice(0, 100)));
  } catch (erreurStockage) {
    // L investigation ne doit jamais dependre de la telemetrie locale.
  }
}

module.exports = {
  rechercherDiagnosticSyncUp,
  chargerSourcesObservablesSyncUp,
  tracerUsageCockpitSyncUp,
};



// WEBPACK FOOTER //
// src/components/cockpitSyncUp/cockpitSyncUpApi.js